import styled from "styled-components";
import {Layout} from "antd";
import {Link} from "react-router-dom";
// import "./index.css";

export const StyledLayout = styled(Layout)`
  /* background-color: #ffffff; */
`;
export const StyledMainSection = styled.main`
  max-width: 143.9rem;
  margin: 0 auto;
  margin-top: 7.101rem;
  padding: 0 4.5rem;

  @media only screen and (max-width: 1120px) {
    padding: 0 1.6rem;
  }
`;
export const StyledOnboardingMainSection = styled.main`
  margin-top: 7.101rem;
`;
export const StyledChildrenAndImageWrapper = styled.div`
  margin: 3rem 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3.8rem;
  @media only screen and (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
`;
export const StyledChildrenWrapper = styled.div`
  /* flex: 1; */
`;
export const StyledAuthFormWrapper = styled.div`
  /* max-width: 67.3rem;
  width: 100%; */
  margin: 0 auto;
  padding: 0 1rem;
  background-color: #fff;
  border: 1px solid #f0f0f0;
  padding: 2.4rem;
  border-radius: 8px;

  .form-main-heading {
    font-weight: 700;
    font-size: 3.8rem;
    font-family: "NewSpirit", "Inter";
  }
  .form-sub-heading {
    font-weight: 400;
    font-size: 1.8rem;
    margin-top: 1rem;
  }

  .login-option {
    font-weight: 400;
    font-size: 14px;
    text-align: center;
  }

  @media only screen and (max-width: 500px) {
    /* margin: 4rem 0;
    max-width: 100%; */
    padding: 1.6rem;
    .form-main-heading {
      font-size: 2.4rem;
    }
    .form-sub-heading {
      font-weight: 400;
      font-size: 1.4rem;
    }
  }
`;
export const StyledImageWrapper = styled.div`
  /* max-width: 58.4rem; */
  @media only screen and (max-width: 1120px) {
    display: none;
  }
`;
export const StyledInfoBlock = styled.div`
  .info-block-text {
    font-weight: 400;
    font-size: 1.2rem;
  }
`;
export const StyledLink = styled(Link)`
  display: block;
  font-weight: 600;
  font-size: 1.4rem;
  margin-top: -1.3rem;
  cursor: pointer;
  color: #1c1726;
  text-decoration: underline;
`;
export const StyledAuthTitleCenterAlign = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
